import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from "react-intl";
import { makeStyles } from '@material-ui/core';

import { AlertMessages } from '../../../components';
import { ALERT_ERROR } from "../../../constants";
import { getI18n } from "../../../utils/intl";

import { useLogin } from "../context";
import { LABELS, TEST_IDS } from '../constants';

import styles from './styles';

const GlobalErrors = () => {
  const intl = getI18n(useIntl());

  const { globalErrors, shouldShowCredentialsError,
    clearGlobalErrors, setShouldShowCredentialsError,
  } = useLogin();
  const {
    eulaNotAccepted, loginError, sessionTimeout,
    loginLocked, contactAdmin, unknownError,
  } = globalErrors;

  return <>
    {eulaNotAccepted
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.eulaNotAccepted}
          message={intl.getI18nMessage(LABELS.eulaNotAcceptedErrorMessage)}
          onClose={() => clearGlobalErrors('eulaNotAccepted')}
        />
      : null
    }
    {loginError
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.loginError}
          message={intl.getI18nMessage(LABELS.loginErrorMessage)}
          onClose={() => clearGlobalErrors('loginError')}
        />
      : null
    }
    {sessionTimeout
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.sessionTimeout}
          message={intl.getI18nMessage(LABELS.sessionTimeoutErrorMessage)}
          onClose={() => clearGlobalErrors('sessionTimeout')}
        />
      : null
    }
    {loginLocked
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.loginLocked}
          message={intl.getI18nMessage(LABELS.loginLockedErrorMessage)}
          onClose={() => clearGlobalErrors('loginLocked')}
        />
      : null
    }
    {contactAdmin
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.contactAdmin}
          message={intl.getI18nMessage(LABELS.contactAdminErrorMessage)}
          onClose={() => clearGlobalErrors('contactAdmin')}
        />
      : null
    }
    {unknownError
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.unknownError}
          message={intl.getI18nMessage(LABELS.unknownErrorMessage)}
          onClose={() => clearGlobalErrors('unknownError')}
        />
      : null
    }
    {shouldShowCredentialsError
      ? <ErrorAlert
          status={ALERT_ERROR} id={TEST_IDS.credentialsError}
          message={intl.getI18nMessage(LABELS.credentialsErrorMessage)}
          onClose={() => setShouldShowCredentialsError(false)}
        />
      : null
    }
  </>
}

const ErrorAlert = ({ status, message, id, onClose }) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return <AlertMessages
    className={classes.alert}
    id={id}
    variant={status}
    message={message}
    onClose={onClose}
  />
}

ErrorAlert.propTypes= {
  status: PropTypes.string,
  message: PropTypes.string,
  id: PropTypes.string,
  onClose: PropTypes.func,
}

export default GlobalErrors;
